const rootURL = 'https://safe-dawn-48616.herokuapp.com/';

export default rootURL;